import { useAddArticleCombinationToCart } from "@lib/hooks/use-add-article-combination-to-cart"
import React, { FC } from "react"
import * as S from "./Buttons.elements"
import LinkAnchor from "@components/Buttons/LinkButton"
import { ChoicesArticleCombination } from "@generated"
import { useIntl } from "@components/Intl"
import { useNotificationsUpdate } from "@components/Notifications"
import IntlLink from "@components/Intl/IntlLink"
import { dataLayerAddToCart } from "@lib/data-layer-events/add-to-cart"

type RelatedCombinationCardButtonsProps = {
  activeProduct: ChoicesArticleCombination
  customizeUrl?: string
}

export const RelatedCombinationCardButtons: FC<
  RelatedCombinationCardButtonsProps
> = ({ activeProduct, customizeUrl }) => {
  const { messages } = useIntl()
  const { addNotification } = useNotificationsUpdate()
  const { mutateAsync, isLoading } = useAddArticleCombinationToCart()

  return (
    <S.Parent>
      {customizeUrl ? (
        <IntlLink href={customizeUrl} as={customizeUrl}>
          <LinkAnchor icon="configure" as="link">
            {messages.global.configure}
          </LinkAnchor>
        </IntlLink>
      ) : (
        <div />
      )}
      <LinkAnchor
        icon="add-to-bag"
        as="button"
        disabled={isLoading}
        onClick={async () => {
          await mutateAsync({
            articleId: activeProduct.id,
          })
          dataLayerAddToCart({
            id: activeProduct.id,
            name: activeProduct.name,
            price: activeProduct.price,
          })
          addNotification({
            type: "success",
            text: `${activeProduct.name} ${messages.cart.addedToCart}`,
          })
        }}
      >
        {messages.global.addToBag}
      </LinkAnchor>
    </S.Parent>
  )
}
